import React from "react";
import { UiButtonPrimary } from "./common/form/UiButton";

export const UiSubscribeNow = () => {

    return (
        <div className="sbt-footer__subscribe">
            <h1>Sign up for Sherbet reward updates</h1>
            <UiButtonPrimary
                name="Subcribe Now"
            />
        </div>
    )
}